import { atom, selector } from 'recoil';
import { v4 } from 'uuid';

import { Percomatic } from '@biggby-coffee/percomatic-typescript';

import { persistAtom } from '../utils/persistAtom';
import { orderScreenHandlerState } from '../atoms';
import { ItemsProps } from './components/Items';
import { TotalsProps } from './components/Totals';
import { castTransItem } from './utils/castTransItem';

export const sessionCartState = atom<Percomatic.Inputs.Transaction>({
	key: 'sessionCartState',
	default: {
		id: v4(),
		items: []
	},
	effects_UNSTABLE: [persistAtom]
});

export const currentTransactionState = selector<
	TotalsProps & { items: ItemsProps['items'] }
>({
	key: 'currentTransaction',
	get({ get }) {
		const { currentTrans } = get(orderScreenHandlerState);

		if (!currentTrans) {
			return {
				items: [],
				subTotal: '0.00',
				taxAmount: '0.00',
				total: '0.00'
			};
		}

		return {
			items: currentTrans.items
				.filter(item => item.isSent)
				.map(castTransItem),
			subTotal: currentTrans.subTotal,
			taxAmount: currentTrans.taxAmount,
			total: currentTrans.total
		};
	}
});

export const cartItemsState = selector<ItemsProps['items']>({
	key: 'cartItems',
	get({ get }) {
		const currentTransaction = get(currentTransactionState);

		return currentTransaction.items;
	}
});

export const cartQuantityState = selector<number>({
	key: 'cartQuantity',
	get({ get }) {
		const cartItems = get(cartItemsState);

		return cartItems.length;
	}
});

export const subTotalState = selector<TotalsProps['subTotal']>({
	key: 'subTotal',
	get({ get }) {
		const currentTransaction = get(currentTransactionState);

		return currentTransaction.subTotal;
	}
});

export const taxAmountState = selector<TotalsProps['taxAmount']>({
	key: 'taxAmount',
	get({ get }) {
		const currentTransaction = get(currentTransactionState);

		return currentTransaction.taxAmount;
	}
});

export const totalState = selector<TotalsProps['total']>({
	key: 'total',
	get({ get }) {
		const currentTransaction = get(currentTransactionState);

		return currentTransaction.total;
	}
});
